// Return `xs` mean
export function mean(xs) {
  if (xs.length <= 0) { throw new Error('`xs` must be of at least length 1') }
  return sum(xs) / xs.length
}

// Return the sum of all `xs` elements
export function sum(xs) {
  return xs.reduce((acc, x) => acc + x, 0)
}

// Return an array which is the result of subtracting `xs` from `ys`
export const subtract = (xs, ys) => {
  if (xs.length !== ys.length) { throw new Error('`xs` and `ys` must be of same length') }
  return Array(xs.length).fill(0).map((_, i) => xs[i] - ys[i])
}


// Return an array which is the result of proj*x
export const proj = (x, projm) => {
    var xp = Array(projm.length).fill(0);
    for (var i=0; i<projm.length; i++)
      for (var j=0; j<projm[0].length; j++) {
        xp[i] += projm[i][j]*x[j];
      }
    return xp
  }
